{
  "ENROLLMENT_CREATED": {
    "title": "Novo curso disponível!",
    "message": "Você foi matriculado em {{productTitle}}"
  },
  "COURSE_COMPLETED": {
    "title": "Curso concluído!",
    "message": "Parabéns! Você concluiu {{productTitle}}"
  },
  "LESSON_COMPLETED": {
    "title": "Aula concluída!",
    "message": "Você completou \"{{lessonTitle}}\""
  },
  "POINTS_EARNED": {
    "title": "Pontos ganhos!",
    "message": "Você ganhou {{points}} XP"
  },
  "COMMUNITY_POINTS_EARNED": {
    "title": "+{{points}} XP na Comunidade!",
    "message": "Você ganhou {{points}} XP na comunidade"
  },
  "LEVEL_UP": {
    "title": "Nível alcançado!",
    "message": "Você subiu para {{levelName}}"
  },
  "COMMENT_REPLY": {
    "title": "Nova resposta ao seu comentário",
    "message": "{{replierName}} respondeu: \"{{snippet}}\""
  },
  "COMMENT_REACTION": {
    "title": "Seu comentário recebeu uma curtida",
    "message": "{{reactorName}} curtiu seu comentário"
  },
  "PAYMENT_APPROVED": {
    "title": "Pagamento confirmado",
    "message": "Seu pagamento de {{offerName}} foi aprovado"
  },
  "DAILY_CHECKLIST_TASK": {
    "title": "Checklist Diário",
    "message": "Você completou a tarefa: {{actionLabel}}! +{{points}} XP"
  },
  "DAILY_CHECKLIST_BONUS": {
    "title": "Trifecta Diária Completa!",
    "message": "Parabéns! Você completou todas as tarefas diárias e ganhou +{{bonusPoints}} XP de bônus!"
  },
  "STREAK_MILESTONE": {
    "title": "{{streakDays}} dias consecutivos!",
    "message": "{{streakDays}} dias consecutivos de estudo!",
    "message_7": "Parabéns! 7 dias consecutivos de estudo! 🔥",
    "message_14": "Impressionante! 2 semanas seguidas estudando! 🚀",
    "message_30": "INCRÍVEL! 30 dias consecutivos! Você é imparável! ⭐",
    "message_60": "Lenda! 60 dias de disciplina pura! 🏆",
    "message_90": "ÉPICO! 90 dias consecutivos! Você é uma inspiração! 💎",
    "message_180": "LENDÁRIO! 6 meses de dedicação absoluta! 👑",
    "message_365": "SUPREMO! 1 ANO COMPLETO! Você fez história! 🌟"
  },
  "STREAK_BROKEN": {
    "title": "Sua sequência foi interrompida",
    "message": "Sua sequência de {{brokenStreak}} dias foi interrompida. Não desista, comece uma nova hoje!"
  },
  "CHALLENGE_COMPLETED": {
    "title": "Desafio Concluído!",
    "message": "Parabéns! Você completou o desafio \"{{challengeTitle}}\"!"
  },
  "WEEKLY_BADGE_EARNED": {
    "title": "Badge Semanal Conquistado!",
    "message": "Parabéns! Você ficou em {{rank}}º lugar na semana e ganhou o badge \"{{badgeName}}\"!"
  },
  "REWARD_REDEEMED": {
    "title": "Recompensa Resgatada!",
    "message": "Você resgatou \"{{rewardTitle}}\" por {{costXp}} XP!"
  },
  "REWARD_STATUS_UPDATED": {
    "title": "Status da Recompensa Atualizado",
    "message": "Status do resgate de \"{{rewardTitle}}\" atualizado.",
    "message_pending": "Seu resgate de \"{{rewardTitle}}\" está sendo processado.",
    "message_processing": "Seu resgate de \"{{rewardTitle}}\" está em processamento.",
    "message_delivered": "Seu resgate de \"{{rewardTitle}}\" foi entregue com sucesso!",
    "message_cancelled": "Seu resgate de \"{{rewardTitle}}\" foi cancelado e o XP foi reembolsado."
  },
  "ADMIN_REDEMPTION_ALERT": {
    "title": "Nova Solicitação de Resgate",
    "message": "Um usuário resgatou \"{{rewardTitle}}\". Ação necessária."
  },
  "checklistActions": {
    "post": "post",
    "comment": "comentário",
    "like": "curtida"
  }
}
